const $ea23bd7a63c9796f$export$31edf49e44578506 = function modFox(state) {
    document.querySelector(".fox").className = `fox fox-${state}`;
};
const $ea23bd7a63c9796f$export$1f9518c2c59b8e99 = function modScene(state) {
    document.querySelector(".game").className = `game ${state}`;
};
const $ea23bd7a63c9796f$export$7ee9422b060e0e7b = function togglePoopBag(show) {
    document.querySelector(".poop-bag").classList.toggle("hidden", !show);
};
const $ea23bd7a63c9796f$export$cd949469e93f219e = function writeModal(text = "") {
    document.querySelector(".modal").innerHTML = `<div class="modal-inner">${text}</div>`;
};


const $30527df661259f19$export$254fa44e74c824df = 3000;
const $30527df661259f19$export$fde44257752a9f60 = [
    "fish",
    "poop",
    "weather"
];
const $30527df661259f19$export$d109769b7b60b20b = 0.2;
const $30527df661259f19$export$d3112996f706f1c = [
    "day",
    "rain"
];
const $30527df661259f19$export$6deaf3182f1c1b32 = 45;
const $30527df661259f19$export$d948a4fe06c2f359 = 3;
const $30527df661259f19$export$57d09a4d1c60d13c = (clock)=>Math.floor(Math.random() * 3) + 5 + clock;
const $30527df661259f19$export$90ecfaab96696ff = (clock)=>Math.floor(Math.random() * 2) + 3 + clock;
const $30527df661259f19$export$c0dfc64653b730bf = (clock)=>Math.floor(Math.random() * 3) + 4 + clock;


const $c9bfdfadb452e31c$var$gameState = {
    current: "INIT",
    scene: -1,
    clock: 1,
    wakeTime: -1,
    sleepTime: -1,
    hungryTime: -1,
    dieTime: -1,
    poopTime: -1,
    timeToStartCelebrating: -1,
    timeToEndCelebrating: -1,
    tick () {
        this.clock++;
        if (this.clock === this.wakeTime) this.wake();
        else if (this.clock === this.sleepTime) this.sleep();
        else if (this.clock === this.hungryTime) this.getHungry();
        else if (this.clock === this.dieTime) this.die();
        else if (this.clock === this.timeToStartCelebrating) this.startCelebrating();
        else if (this.clock === this.timeToEndCelebrating) this.endCelebrating();
        else if (this.clock === this.poopTime) this.poop();
        return this.clock;
    },
    startGame () {
        this.current = "HATCHING";
        this.wakeTime = this.clock + 3;
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("egg");
        (0, $ea23bd7a63c9796f$export$1f9518c2c59b8e99)("day");
        (0, $ea23bd7a63c9796f$export$cd949469e93f219e)();
    },
    wake () {
        this.current = "IDLING";
        this.wakeTime = -1;
        this.scene = Math.random() > (0, $30527df661259f19$export$d109769b7b60b20b) ? 0 : 1;
        (0, $ea23bd7a63c9796f$export$1f9518c2c59b8e99)((0, $30527df661259f19$export$d3112996f706f1c)[this.scene]);
        this.sleepTime = this.clock + (0, $30527df661259f19$export$6deaf3182f1c1b32);
        this.hungryTime = (0, $30527df661259f19$export$57d09a4d1c60d13c)(this.clock);
        this.determineFoxState();
    },
    sleep () {
        this.current = "SLEEP";
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("sleep");
        (0, $ea23bd7a63c9796f$export$1f9518c2c59b8e99)("night");
        this.clearTimes();
        this.wakeTime = this.clock + (0, $30527df661259f19$export$d948a4fe06c2f359);
    },
    clearTimes () {
        this.wakeTime = -1;
        this.sleepTime = -1;
        this.hungryTime = -1;
        this.dieTime = -1;
        this.poopTime = -1;
        this.timeToStartCelebrating = -1;
        this.timeToEndCelebrating = -1;
    },
    getHungry () {
        this.current = "HUNGRY";
        this.dieTime = (0, $30527df661259f19$export$90ecfaab96696ff)(this.clock);
        this.hungryTime = -1;
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("hungry");
    },
    poop () {
        this.current = "POOPING";
        this.poopTime = -1;
        this.dieTime = (0, $30527df661259f19$export$90ecfaab96696ff)(this.clock);
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("pooping");
    },
    die () {
        this.current = "DEAD";
        (0, $ea23bd7a63c9796f$export$1f9518c2c59b8e99)("dead");
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("dead");
        this.clearTimes();
        (0, $ea23bd7a63c9796f$export$cd949469e93f219e)("The fox died :( <br/> Press the middle button to restart");
    },
    startCelebrating () {
        this.current = "CELEBRATING";
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("celebrate");
        this.timeToStartCelebrating = -1;
        this.timeToEndCelebrating = this.clock + 2;
    },
    endCelebrating () {
        this.current = "IDLING";
        this.timeToEndCelebrating = -1;
        this.determineFoxState();
        (0, $ea23bd7a63c9796f$export$7ee9422b060e0e7b)(false);
    },
    determineFoxState () {
        if (this.current === "IDLING") {
            if ((0, $30527df661259f19$export$d3112996f706f1c)[this.scene] === "rain") (0, $ea23bd7a63c9796f$export$31edf49e44578506)("rain");
            else (0, $ea23bd7a63c9796f$export$31edf49e44578506)("idling");
        }
    },
    handleUserAction (icon) {
        if ([
            "SLEEP",
            "FEEDING",
            "CELEBRATING",
            "HATCHING"
        ].includes(this.current)) // do nothing
        return;
        if (this.current === "INIT" || this.current === "DEAD") {
            this.startGame();
            return;
        }
        switch(icon){
            case "weather":
                this.changeWeather();
                break;
            case "poop":
                this.cleanUpPoop();
                break;
            case "fish":
                this.feed();
        }
    },
    changeWeather () {
        this.scene = (this.scene + 1) % (0, $30527df661259f19$export$d3112996f706f1c).length;
        (0, $ea23bd7a63c9796f$export$1f9518c2c59b8e99)((0, $30527df661259f19$export$d3112996f706f1c)[this.scene]);
        this.determineFoxState();
    },
    cleanUpPoop () {
        if (this.current !== "POOPING") return;
        this.dieTime = -1;
        (0, $ea23bd7a63c9796f$export$7ee9422b060e0e7b)(true);
        this.startCelebrating();
        this.hungryTime = (0, $30527df661259f19$export$57d09a4d1c60d13c)(this.clock);
    },
    feed () {
        if (this.current !== "HUNGRY") return;
        this.current = "FEEDING";
        this.dieTime = -1;
        this.poopTime = (0, $30527df661259f19$export$c0dfc64653b730bf)(this.clock);
        (0, $ea23bd7a63c9796f$export$31edf49e44578506)("eating");
        this.timeToStartCelebrating = this.clock + 2;
    }
};
const $c9bfdfadb452e31c$export$ccab573699251c80 = $c9bfdfadb452e31c$var$gameState.handleUserAction.bind($c9bfdfadb452e31c$var$gameState);
var $c9bfdfadb452e31c$export$2e2bcd8739ae039 = $c9bfdfadb452e31c$var$gameState;




const $30be943f8bd0d4a2$var$toggleHighlighted = (icon, show)=>document.querySelector(`.${(0, $30527df661259f19$export$fde44257752a9f60)[icon]}-icon`).classList.toggle("highlighted", show);
function $30be943f8bd0d4a2$export$2e2bcd8739ae039(handleUserAction) {
    let selectedIcon = 0;
    function buttonClick({ target: target }) {
        if (target.classList.contains("left-btn")) {
            $30be943f8bd0d4a2$var$toggleHighlighted(selectedIcon, false);
            selectedIcon = (2 + selectedIcon) % (0, $30527df661259f19$export$fde44257752a9f60).length;
            $30be943f8bd0d4a2$var$toggleHighlighted(selectedIcon, true);
        } else if (target.classList.contains("right-btn")) {
            $30be943f8bd0d4a2$var$toggleHighlighted(selectedIcon, false);
            selectedIcon = (1 + selectedIcon) % (0, $30527df661259f19$export$fde44257752a9f60).length;
            $30be943f8bd0d4a2$var$toggleHighlighted(selectedIcon, true);
        } else handleUserAction((0, $30527df661259f19$export$fde44257752a9f60)[selectedIcon]);
    }
    document.querySelector(".buttons").addEventListener("click", buttonClick);
}


async function $ed1f10388746f9c3$var$init() {
    (0, $30be943f8bd0d4a2$export$2e2bcd8739ae039)((0, $c9bfdfadb452e31c$export$ccab573699251c80));
    let nextTimeToTick = Date.now();
    function nextAnimationFrame() {
        const now = Date.now();
        if (nextTimeToTick < now) {
            (0, $c9bfdfadb452e31c$export$2e2bcd8739ae039).tick();
            nextTimeToTick = now + (0, $30527df661259f19$export$254fa44e74c824df);
        }
        requestAnimationFrame(nextAnimationFrame);
    }
    requestAnimationFrame(nextAnimationFrame);
}
$ed1f10388746f9c3$var$init();


//# sourceMappingURL=index.455d9944.js.map
